import StaticIcon from '../../../components/Icons/StaticIcon';
import VideoIcon from '../../../components/Icons/VideoIcon';

export const AD_FORMATS = [
  {
    id: 'video',
    Icon: VideoIcon,
    displayName: 'Video',
  },
  {
    id: 'image',
    Icon: StaticIcon,
    displayName: 'Static',
  },
];
